// Currency-specific minor-unit rendering. Amounts from different currencies are
// NEVER combined — callers pass a single currency + its own minor amount.
const ZERO_DECIMAL = new Set(['JPY', 'KRW', 'VND', 'CLP', 'ISK']);

export function minorUnitDigits(currency: string): number {
  return ZERO_DECIMAL.has(currency.toUpperCase()) ? 0 : 2;
}

export function formatMinor(currency: string, amountMinor: number): string {
  const digits = minorUnitDigits(currency);
  const major = amountMinor / 10 ** digits;
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency, minimumFractionDigits: digits, maximumFractionDigits: digits }).format(major);
  } catch {
    return `${currency} ${major.toFixed(digits)}`;
  }
}
